import { render, staticRenderFns } from "./MainManage.vue?vue&type=template&id=2b685288&scoped=true&"
import script from "./MainManage.vue?vue&type=script&lang=js&"
export * from "./MainManage.vue?vue&type=script&lang=js&"
import style0 from "./MainManage.vue?vue&type=style&index=0&id=2b685288&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b685288",
  null
  
)

export default component.exports